export default __webpack_public_path__ + "images/b705b8aee89c4ab699cf13c3dd15197a.svg";